import type { GetCollaboratorsResponseType } from "@nlc/shared-types";

export const MOCKED_COLLABORATORS: GetCollaboratorsResponseType = {
  collaborators: [
    {
      avatar: "",
      id: 1,
      name: "Mock User 1",
    },
    {
      avatar: "",
      id: 2,
      name: "Mock User 2",
    },
  ],
};
